<template>
  <div>
    <div @click="close" class="previewModal"></div>
    <div class="inner">
      <menuPreviewHeader />
      <div class="categoryList">
        <div class="categoryList-category">
          <span class="categoryList-category-name">{{
            currentCategoryName
          }}</span>
        </div>
      </div>
      <div class="itemList">
        <div
          v-for="(item, key) in menuItemsByCategoryCode(currentCategoryCode)"
          :key="key"
          :class="{ w100: item.wideView === 1 }"
          style="width:50%; float: left"
        >
          <div v-if="item.unVisibleFlag === 0">
            <div v-if="item.wideView === 1">
              <img :src="imageByItemCode(item.itemCode).largeImage" alt="" />
            </div>
            <div v-else>
              <img :src="imageByItemCode(item.itemCode).normalImage" alt="" />
            </div>
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <menuPreviewFooter />
    </div>
  </div>
</template>
<script>
import menuPreviewHeader from '@/components/menuPreviewModal/MenuPreviewHeader'
import menuPreviewFooter from '@/components/menuPreviewModal/MenuPreviewFooter'
import { mapGetters } from 'vuex'

export default {
  components: {
    menuPreviewHeader,
    menuPreviewFooter,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      currentCategoryCode: 'menu/getCurrentCategoryCode',
      currentCategoryName: 'menu/getCurrentCategoryName',
      menuItemsByCategoryCode: 'menu/getMenuItemsByCategoryCode',
      imageByItemCode: 'menu/getImageByItemCode',
      language: 'settings/getLanguage',
    }),
  },
  methods: {
    close: function() {
      this.$store.dispatch('menu/updateIsShowPreviewModal', false)
    },
  },
}
</script>
<style lang="scss" scoped>
img {
  max-width: 100%;
}
.categoryList {
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  width: 100%;
  &-category {
    color: #d21b24;
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 35px;
    padding: 5px;
    box-sizing: border-box;
    border-bottom: solid 1px #ccc;
    &-name {
      display: inline-block;
      position: relative;
      padding: 0 10px;
      &::after {
        position: absolute;
        bottom: -6px;
        left: 0;
        display: block;
        content: '';
        height: 2px;
        width: 100%;
        background-color: #d21b24;
      }
    }
  }
}
.itemList {
  background-color: #ddd;
}
.previewModal {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: fixed;
}
.inner {
  position: absolute;
  width: 420px;
  top: 35px;
  left: 50%;
  margin-left: -210px;
  background-color: #fff;
  box-sizing: border-box;
}
.w100 {
  clear: both;
  width: 100% !important;
}
</style>
